import React, { useState, useEffect, useRef } from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client'
import { useMediaQuery } from 'react-responsive';
import './styles.scss';
import { Provider } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchInfoCalendar } from '@Redux/search/actions';
import { store, RootState } from '@Redux/search/store';
import {
    WarningIcon,
    TelephoneIcon,
    EarthFlightIcon,
    SearchFlightIcon,
    CallIcon,
} from '@features/ui/Icons';

import { SearchToolbar } from '@features/toolbars';
import { SearchTimeout } from '@features/timeouts';
import Skeleton from '@features/skeletons';
import { Notification } from '@features/announcements';
import { SwitchSalesMode } from '@features/switchStatus';
import SearchPanel from '@features/searchPanel';
import Filters from '@components/SearchPage/Filters';
import SearchResultCards from '@features/searchResultCards';
import ResultNoData from '@features/noResult/SearchNoData';
import useShowControl from '@hooks/useShowControl';
import type { I_NoticeInfo } from '@Redux/search/interfaces';
import PromotionEntrance from '@features/PromotionEntrance';
import RateChartLightBox from '@features/lightbox/RateChartLightBox';
import FlightRateCarousel from '@features/FlightRateCarousel';
import { getRtowText, RTOW_SINGLE, RTOW_RETURN, RTOW_MULTI } from '@utils/utils';
import LoadingProgress from '@features/LoadingProgress';
declare global {
    interface Window {
        SearchPanel: any;
        salesmode: boolean;
        Templates: {
            login_lion: {
                default: {
                    OpenLogin(): any;
                };
            };
        };
    }
}

// console.log('Current Environment: ', process.env.ENV);

const Search = () => {
    const moduleClass = 'search';
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const renderCount = useRef(0)
    const dispatch = useDispatch();
    const { SearchPrice, SearchInfoCalendar, UrlParams, NoticeInfo, SaleInfo } = useSelector((state: RootState) => state.search);
    const [showRateChartLightBox, setShowRateChartLightBox] = useState(false);
    const [isOpenFilter, setIsOpenFilter] = useState(false);

    const handleOpenFilter = () => setIsOpenFilter(true);

    const { isOpen: isOpenPanelM, open: openPanelM, close: closePanelM } = useShowControl();

    const { Rtow } = UrlParams;

    const handleOpenCalendar = () => {
        $('#searchpanelPC .tabContent.active .calendarInput')
            .find('.inputSkin_group_content')
            .eq(0)
            .trigger('click');
    };

    const handleOpenDep = () => {
        $('#searchpanelPC .tabContent.active .placeAndDateGroup ')
            .find('.inputSkin_group_content')
            .eq(0)
            .trigger('click');
    };

    useEffect(() => {
        closePanelM();
    }, [closePanelM]);

    useEffect(() => {
        // 等redux的SearchPrice.data(搜尋結果區塊)更新後，才打價格輪播的API(不論SearchPrice.data是否有資料皆是)，以取得最新每日價格資訊
        if (SearchPrice.isLoading) return
        dispatch(setSearchInfoCalendar(UrlParams));
    }, [SearchPrice.isLoading])


    const contactLink = isMobile
        ? 'tel:0287939660'
        : 'https://info.liontravel.com/category/zh-tw/store/index';

    const searchBody = (() => {
        // 預設畫面
        if (location.search.length <= 0) {
            return (
                <ResultNoData
                    icon={<EarthFlightIcon />}
                    content="預訂優惠機票出發去旅行，開始探索航班吧！"
                    linkText="立即搜尋"
                    onLinkClick={isMobile ? openPanelM : handleOpenDep}
                />
            );
        }

        // Loading
        if (SearchPrice.isLoading) {
            return isMobile ? (
                <div className={moduleClass}>
                    <div className={`${moduleClass}_content`}>
                        <Skeleton part="cards" device="m" />
                    </div>
                </div>
            ) : (
                <div className={moduleClass}>
                    <Skeleton part="filter" />
                    <div className={`${moduleClass}_content`}>
                        <Skeleton part="cards" device="pc" />
                    </div>
                </div>
            );
        }

        // 24 小時内有機票，24 小時後沒有機票
        if (SaleInfo && (!SearchPrice.data.FlightInfos || SearchPrice.data.FlightInfos?.length === 0)) {
            const handleContactAction = () => window.open(contactLink, '_blank');
            return SaleInfo?.map((Info: I_NoticeInfo, i: number) => (
                <ResultNoData
                    key={i}
                    icon={<CallIcon />}
                    content={Info.Notice.replace(`${Info.NoticeUrl[0].UrlStr}`, '')}
                    linkText={Info.NoticeUrl[0].UrlStr}
                    onLinkClick={handleContactAction}
                />
            ));
        }

        // 查無結果
        if (!SearchPrice.data.FlightInfos || SearchPrice.data.FlightInfos?.length === 0)
            return (
                <ResultNoData
                    icon={<SearchFlightIcon />}
                    content="您選擇的日期/時段目前查無航班。建議你..."
                    linkText="選擇其他日期後重新查詢"
                    onLinkClick={isMobile ? openPanelM : handleOpenCalendar}
                />
            );

        console.log("23234234234");
        console.log(SearchInfoCalendar.data);
        console.log(SearchPrice.data);


        // 搜尋結果
        return (
            <div className={moduleClass}>
                <Filters open={isOpenFilter} whenClose={(open: boolean) => setIsOpenFilter(open)} />
                <div className={`${moduleClass}_content`}>
                    <SearchToolbar handleToolbarClick={handleOpenFilter} />
                    <PromotionEntrance className='imageWrap_m' />
                    {!window.salesmode && SaleInfo?.map((Info: I_NoticeInfo, i: number) => (
                        <Notification
                            key={i}
                            noticeType="請洽客服"
                            color="blue"
                            content={Info.Notice.replace(`${Info.NoticeUrl[0].UrlStr}`, '')}
                            link={contactLink}
                            linkText={Info.NoticeUrl[0].UrlStr}
                            icon={<TelephoneIcon />}
                        />
                    ))}
                    {!window.salesmode && NoticeInfo?.map((Info: I_NoticeInfo, i: number) => (
                        <Notification
                            key={i}
                            noticeType="重要公告"
                            color="red"
                            content={Info.Notice.replace(`${Info.NoticeUrl[0].UrlStr}`, '')}
                            link={Info.NoticeUrl[0].Url}
                            linkText={Info.NoticeUrl[0].UrlStr}
                            icon={<WarningIcon />}
                        />
                    ))}
                    {window.salesmode && <SwitchSalesMode />}
                    <SearchResultCards
                        openPanelM={openPanelM}
                        openCalendarPC={handleOpenCalendar}
                    />
                </div>
            </div>
        );
    })();

    function handleTrendModalOpen() {
        setShowRateChartLightBox(true);
    }

    function handleTrendModalClose() {
        setShowRateChartLightBox(false);
    }

    return (
        <>
            <SearchPanel
                isOpenPanelM={isOpenPanelM}
                openPanelM={openPanelM}
                closePanelM={closePanelM}
            />
            {SearchInfoCalendar.data && <RateChartLightBox isOpen={showRateChartLightBox} handleTrendModalClose={handleTrendModalClose} />}
            {location.search.length > 0 && <LoadingProgress />}
            {location.search.length > 0 && Rtow !== RTOW_MULTI && SearchInfoCalendar.data !== null && <FlightRateCarousel handleTrendModalOpen={handleTrendModalOpen} />}
            <div className="container main-container">{searchBody}</div>
            {!SearchPrice.isLoading && <SearchTimeout />}
        </>
    );
};



const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Search />
        </Provider>
    </React.StrictMode>,
)

export default Search;
